module.exports = __webpack_public_path__ + "img/bg.37dca38f.png";